module.exports = __webpack_public_path__ + "img/icon-filters.c0b258d4.svg";